/*
 * @Description: 文件说明
 * @Author: Scarlett Xiao
 * @Date: 2022-01-14 11:39:52
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-10-25 14:08:36
 */


/**
 * @brief: 替换oos路径
 * @author: Scarlett Xiao
 * @Date: 2022-01-14 13:50:08
 * @param {*} txt 含oos路径的文本
 */
const OSSUrl = function (txt) {
  if (!txt) {
    return null;
  }
  const oosBase = '/oss';
  txt = txt.replace(
    /\<li/g,
    '<li style="list-style:unset;"'
  );
  txt = txt.replace(
    /\<video/g,
    '<video Controls'
  );
  if (document.location.hostname == 'localhost' || document.location.hostname.indexOf('192.168.') > -1) {
    // dev
    txt = txt.replace(/agri-cloud.oss-cn-shenzhen.aliyuncs.com/g, `www.uyu1027.com${ oosBase}`);
  } else {
    // serve
    const hostname = window.location.hostname.replace(/http|https:\/\//g, '');
    txt = txt.replace(/agri-cloud.oss-cn-shenzhen.aliyuncs.com/g, `${ hostname + oosBase}`);
  }

  return txt;
}


export {
  OSSUrl
}